module.exports = __webpack_public_path__ + "static/scienceSafety-7250dfb4a8494872957443d392030414.jpg";